/* tslint:disable */
import { loadStyles } from '@microsoft/load-themed-styles';

const styles = {
  customButtonContainer: 'customButtonContainer_0e07c08e',
  icon: 'icon_0e07c08e',
  themeDarkAltColor: 'themeDarkAltColor_0e07c08e',
  leftText: 'leftText_0e07c08e',
  splitter: 'splitter_0e07c08e',
  button: 'button_0e07c08e',
  darkerBG: 'darkerBG_0e07c08e',
};

export = styles;

loadStyles([{"rawString":".customButtonContainer_0e07c08e{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.icon_0e07c08e{display:inline-block;font-family:FabricMDL2Icons;font-style:normal;font-weight:400;speak:none;font-size:14px;position:relative}.themeDarkAltColor_0e07c08e{color:"},{"theme":"themeDarkAlt","defaultValue":"#106ebe"},{"rawString":"}.leftText_0e07c08e{margin-left:6px;font-size:14px;font-weight:400;color:"},{"theme":"neutralPrimary","defaultValue":"#333333"},{"rawString":"}.splitter_0e07c08e{font-size:14px;font-weight:400;color:"},{"theme":"neutralTertiary","defaultValue":"#a6a6a6"},{"rawString":";background:0 0;position:relative;top:-2px;height:40px}.button_0e07c08e.ms-Button{height:40px;min-width:28px;padding:0 5px}.button_0e07c08e:hover{background:initial}.darkerBG_0e07c08e{background:#d0d0d0}"}]);
/* tslint:enable */